var map = {
	"./emoji/0.gif": "./src/packages/chat/emoji/0.gif",
	"./emoji/1.gif": "./src/packages/chat/emoji/1.gif",
	"./emoji/10.gif": "./src/packages/chat/emoji/10.gif",
	"./emoji/11.gif": "./src/packages/chat/emoji/11.gif",
	"./emoji/12.gif": "./src/packages/chat/emoji/12.gif",
	"./emoji/13.gif": "./src/packages/chat/emoji/13.gif",
	"./emoji/14.gif": "./src/packages/chat/emoji/14.gif",
	"./emoji/15.gif": "./src/packages/chat/emoji/15.gif",
	"./emoji/16.gif": "./src/packages/chat/emoji/16.gif",
	"./emoji/17.gif": "./src/packages/chat/emoji/17.gif",
	"./emoji/18.gif": "./src/packages/chat/emoji/18.gif",
	"./emoji/19.gif": "./src/packages/chat/emoji/19.gif",
	"./emoji/2.gif": "./src/packages/chat/emoji/2.gif",
	"./emoji/20.gif": "./src/packages/chat/emoji/20.gif",
	"./emoji/21.gif": "./src/packages/chat/emoji/21.gif",
	"./emoji/22.gif": "./src/packages/chat/emoji/22.gif",
	"./emoji/23.gif": "./src/packages/chat/emoji/23.gif",
	"./emoji/24.gif": "./src/packages/chat/emoji/24.gif",
	"./emoji/25.gif": "./src/packages/chat/emoji/25.gif",
	"./emoji/26.gif": "./src/packages/chat/emoji/26.gif",
	"./emoji/27.gif": "./src/packages/chat/emoji/27.gif",
	"./emoji/28.gif": "./src/packages/chat/emoji/28.gif",
	"./emoji/29.gif": "./src/packages/chat/emoji/29.gif",
	"./emoji/3.gif": "./src/packages/chat/emoji/3.gif",
	"./emoji/30.gif": "./src/packages/chat/emoji/30.gif",
	"./emoji/31.gif": "./src/packages/chat/emoji/31.gif",
	"./emoji/32.gif": "./src/packages/chat/emoji/32.gif",
	"./emoji/33.gif": "./src/packages/chat/emoji/33.gif",
	"./emoji/34.gif": "./src/packages/chat/emoji/34.gif",
	"./emoji/35.gif": "./src/packages/chat/emoji/35.gif",
	"./emoji/36.gif": "./src/packages/chat/emoji/36.gif",
	"./emoji/37.gif": "./src/packages/chat/emoji/37.gif",
	"./emoji/38.gif": "./src/packages/chat/emoji/38.gif",
	"./emoji/39.gif": "./src/packages/chat/emoji/39.gif",
	"./emoji/4.gif": "./src/packages/chat/emoji/4.gif",
	"./emoji/40.gif": "./src/packages/chat/emoji/40.gif",
	"./emoji/41.gif": "./src/packages/chat/emoji/41.gif",
	"./emoji/42.gif": "./src/packages/chat/emoji/42.gif",
	"./emoji/43.gif": "./src/packages/chat/emoji/43.gif",
	"./emoji/44.gif": "./src/packages/chat/emoji/44.gif",
	"./emoji/45.gif": "./src/packages/chat/emoji/45.gif",
	"./emoji/46.gif": "./src/packages/chat/emoji/46.gif",
	"./emoji/47.gif": "./src/packages/chat/emoji/47.gif",
	"./emoji/48.gif": "./src/packages/chat/emoji/48.gif",
	"./emoji/49.gif": "./src/packages/chat/emoji/49.gif",
	"./emoji/5.gif": "./src/packages/chat/emoji/5.gif",
	"./emoji/50.gif": "./src/packages/chat/emoji/50.gif",
	"./emoji/51.gif": "./src/packages/chat/emoji/51.gif",
	"./emoji/52.gif": "./src/packages/chat/emoji/52.gif",
	"./emoji/53.gif": "./src/packages/chat/emoji/53.gif",
	"./emoji/54.gif": "./src/packages/chat/emoji/54.gif",
	"./emoji/55.gif": "./src/packages/chat/emoji/55.gif",
	"./emoji/56.gif": "./src/packages/chat/emoji/56.gif",
	"./emoji/57.gif": "./src/packages/chat/emoji/57.gif",
	"./emoji/58.gif": "./src/packages/chat/emoji/58.gif",
	"./emoji/59.gif": "./src/packages/chat/emoji/59.gif",
	"./emoji/6.gif": "./src/packages/chat/emoji/6.gif",
	"./emoji/60.gif": "./src/packages/chat/emoji/60.gif",
	"./emoji/61.gif": "./src/packages/chat/emoji/61.gif",
	"./emoji/62.gif": "./src/packages/chat/emoji/62.gif",
	"./emoji/63.gif": "./src/packages/chat/emoji/63.gif",
	"./emoji/64.gif": "./src/packages/chat/emoji/64.gif",
	"./emoji/65.gif": "./src/packages/chat/emoji/65.gif",
	"./emoji/66.gif": "./src/packages/chat/emoji/66.gif",
	"./emoji/67.gif": "./src/packages/chat/emoji/67.gif",
	"./emoji/68.gif": "./src/packages/chat/emoji/68.gif",
	"./emoji/69.gif": "./src/packages/chat/emoji/69.gif",
	"./emoji/7.gif": "./src/packages/chat/emoji/7.gif",
	"./emoji/70.gif": "./src/packages/chat/emoji/70.gif",
	"./emoji/71.gif": "./src/packages/chat/emoji/71.gif",
	"./emoji/8.gif": "./src/packages/chat/emoji/8.gif",
	"./emoji/9.gif": "./src/packages/chat/emoji/9.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/packages/chat sync recursive ^.*\\.gif$";